var _path, _path2, _path3, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 76,
    viewBox: "0 0 88 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 10.4772 4.47715 6 10 6H72C77.5228 6 82 10.4772 82 16V19H0V16Z",
    fill: "#C8D1D9",
    className: "header"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 75.5L9.99999 75.5C4.75329 75.5 0.499993 71.2467 0.499993 66L0.499997 19.5L81.5 19.5L81.5 66C81.5 71.2467 77.2467 75.5 72 75.5Z",
    stroke: "#C8D1D9",
    className: "border"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M82 66C82 71.5228 77.5228 76 72 76L9.99999 76C4.47715 76 -7.30844e-06 71.5228 -6.91253e-06 66L-3.54325e-06 19L82 19L82 66Z",
    fill: "#C8D1D9",
    className: "body"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 13,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 13,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 13,
    r: 3,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 5,
    y: 28,
    width: 8,
    height: 8,
    rx: 3,
    stroke: "#EBEEF1",
    strokeWidth: 2,
    className: "check-box"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 5,
    y: 43,
    width: 8,
    height: 8,
    rx: 3,
    stroke: "#EBEEF1",
    strokeWidth: 2,
    className: "check-box"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 5,
    y: 58,
    width: 8,
    height: 8,
    rx: 3,
    stroke: "#EBEEF1",
    strokeWidth: 2,
    className: "check-box"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16,
    y: 28,
    width: 62,
    height: 8,
    rx: 3,
    fill: "#EBEEF1",
    className: "row"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16,
    y: 43,
    width: 62,
    height: 8,
    rx: 3,
    fill: "#EBEEF1",
    className: "row"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16,
    y: 58,
    width: 62,
    height: 8,
    rx: 3,
    fill: "#EBEEF1",
    className: "row"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13C62 5.824 67.824 1.0183e-06 75 2.27299e-06C82.176 3.52768e-06 88 5.824 88 13C88 20.176 82.176 26 75 26C67.824 26 62 20.176 62 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.ed02b0ff52ffcacf8fdc43f337e313ef.svg";
export { ForwardRef as ReactComponent };